<section class="component-tab component-tab--team team-page new-team-page">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 col-md-12 tab-title__col" *ngIf="teamData">
				<h2 class="tab__title" *ngIf="teamData.team_block_title != ''" [innerHtml]="teamData.team_block_title"></h2>
			</div>
			<div class="col-12 col-md-12 community community__participants-listing">
				<div class="contact-wrapper" *ngIf="teamData">
					<div class="contact__icon">
						<i class="icon-email"></i>
					</div>
					<div class="contact__links">
						<div class="contact__repeater" *ngFor="let tiVal of team_contact_info">
							<strong class="contact__type" [innerHtml]="tiVal.team_info_title"></strong>
							<span class="contact__email"><a href="mailto:{{ tiVal.team_info_email }}" [innerHtml]="tiVal.team_info_email"></a></span>
						</div>
					</div>
				</div>
				<div class="masonry-section masonry-section-js team-grid row" *ngIf="new_team">
					<div class="grid-sizer-3"></div>
					<div class="col-12 col-sm-6 col-md-4 masonry-item team-grid-item" *ngFor="let plVal of new_team; let odd = odd; let even = even">
						<div class="news__link">
							<a class="masonry-link" routerLink="/team/{{ plVal.team_slug }}">
								<figure class="news__image" *ngIf="false != plVal.team_img">
									<img [defaultImage]="plVal.team_img" [lazyLoad]="plVal.team_img" alt="{{ plVal.team_name }}" class="img-responsive" loading="lazy" width="228" />
								</figure>
								<figure class="news__image no-image {{ odd ? 'odd-list' : 'even-list' }}" *ngIf="false == plVal.team_img">
								</figure>
								<div class="news__content">
									<h3>{{ plVal.team_name | titlecase }}</h3>
									<p *ngIf="plVal?.team_position != '' || pVal?.team_content != ''">
										<span class="working-as" *ngIf="plVal.team_position != ''" [innerHtml]="plVal.team_position"></span>
										<span class="working-at" *ngIf="plVal.team_content != ''" [innerHtml]="plVal.team_content | truncatetext: 20 |  safe:'preamble'"></span>
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div class="text-center load-more link-wrapper load-more-large">
					<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreTeam()" id="show-more-button" *ngIf="!loadMoreButton && showMoreButton"><b>Show More</b> <span><i class="icon-breadcrumb-bottom"></i></span></a>				
					<span *ngIf="loadMoreButton"><span class="loading__circle loading__circle-small"></span></span>
				</div>
			</div>
		</div>
	</div>
</section>